import React, { SVGProps } from 'react';

export const RobotSm = ({ color = 'white', ...props }: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <g clip-path="url(#clip0_11883_44)">
      <path
        d="M12.5 3.5H3.5C2.67157 3.5 2 4.17157 2 5V12C2 12.8284 2.67157 13.5 3.5 13.5H12.5C13.3284 13.5 14 12.8284 14 12V5C14 4.17157 13.3284 3.5 12.5 3.5Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.25 9H5.75C5.05964 9 4.5 9.55964 4.5 10.25C4.5 10.9404 5.05964 11.5 5.75 11.5H10.25C10.9404 11.5 11.5 10.9404 11.5 10.25C11.5 9.55964 10.9404 9 10.25 9Z"
        stroke={color}
        stroke-width="0.75"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M9 9V11.5" stroke={color} stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M7 9V11.5" stroke={color} stroke-width="0.75" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M8 3.5V1" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M5.25 7.375C5.59518 7.375 5.875 7.09518 5.875 6.75C5.875 6.40482 5.59518 6.125 5.25 6.125C4.90482 6.125 4.625 6.40482 4.625 6.75C4.625 7.09518 4.90482 7.375 5.25 7.375Z"
        fill={color}
      />
      <path
        d="M10.75 7.375C11.0952 7.375 11.375 7.09518 11.375 6.75C11.375 6.40482 11.0952 6.125 10.75 6.125C10.4048 6.125 10.125 6.40482 10.125 6.75C10.125 7.09518 10.4048 7.375 10.75 7.375Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_11883_44">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
